// Replaced at build time by webpack (EnvironmentPlugin) / vite (define)
declare const process: { env: { REQUESTED_PARTITION?: string } };

/**
 * Derives the partition identifier from window.location.host.
 *
 * Hostname patterns (checked in order):
 *  - Stage app: stage.app.*                        → 0
 *  - Prod app:  app.shipstation.com                → 13 (m partition)
 *  - DDE:       *-devss###.* or *-devz.*           → "ss###" / "z"
 *  - Ship prod: ship###.*                          → numeric partition
 *  - Fallback:  process.env.REQUESTED_PARTITION    → parsed numeric value
 *  - Default:                                      → 0
 */

/** Matches DDE-style hostnames: lite-devss220, v3-devss104, ship-devz, etc. */
const ddeMatch = /(?:\w+)-dev(ss\d+|z)(?=\.)/i;

/** Matches production ship hostnames: ship2.shipstation.com, ship.shipstation.com */
const shipMatch = /ship(\d*)(?=\.)/;

/**
 * Returns the partition identifier for the current environment.
 *
 * For DDE environments (e.g. `lite-devss220.sslocal.com`) this returns a
 * string like `"ss220"`. For production (e.g. `ship2.shipstation.com`) it
 * returns the numeric partition (e.g. `2`). Falls back to the
 * `REQUESTED_PARTITION` env var (set by `yarn switch`), then `0`.
 */
export const getPartitionNumber = (): number | string => {
  const { host } = window.location;

  // stage.app.shipstation.com → Z partition
  if (/^stage\.app\./i.test(host)) {
    return 0;
  }

  // app.shipstation.com → M partition (13)
  if (/^app\./i.test(host)) {
    return 13;
  }

  const dde = host.match(ddeMatch);
  if (dde) {
    return dde[1];
  }

  const ship = host.match(shipMatch);
  if (ship) {
    // ship.shipstation.com CNAMEs to ship2.shipstation.com
    if (ship[1] === '') {
      return 2;
    }
    return Number.parseInt(ship[1], 10) || 0;
  }

  if (process.env.REQUESTED_PARTITION) {
    const partitionMatch = process.env.REQUESTED_PARTITION.match(/(\d+)/);
    if (partitionMatch) {
      return Number.parseInt(partitionMatch[1], 10);
    }
  }

  return 0;
};
